import { Flex, type CheckboxOptionType } from 'antd';

import { Avatar } from '@app/components';
import type { NClients } from '@app/types';
import { transformImportedName } from '@app/utils';

export const getEmployeesOptions = (
  employees: NClients.ModelClientsFilterData['Employees']
): CheckboxOptionType<
  NClients.ModelClientsFilterData['Employees'][number]['Id']
>[] => {
  return employees.map(({ Id, NameFirst, NameLast, Photo }) => {
    const fullName = `${NameLast} ${NameFirst}`.trim();
    return {
      label: (
        <Flex align="center" gap={8}>
          <Avatar
            src={Photo}
            size={24}
            nameFirst={NameFirst}
            nameLast={NameLast}
          />
          {transformImportedName(fullName)}
        </Flex>
      ),
      value: Id,
      title: fullName,
    };
  });
};
